import _ from 'lodash';
import { GET_PAST_FEATURE_LIST } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
  contentList: [],
};

/**
 * Site Main Info Reducer
 * @param {*} state
 * @param {*} action
 */
export default function pastFeatureList(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_PAST_FEATURE_LIST}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_PAST_FEATURE_LIST}_SUCCESS`:
      let contentList;
      if (action.bStart === 0) {
        contentList = action?.result?.data?.attributes?.data;
      } else {
        contentList = _.concat(
          state.contentList ?? [],
          action?.result?.data?.attributes?.data,
        );
      }
      return {
        ...state,
        error: null,
        result: action?.result,
        contentList: contentList,
        // contentList: _.concat(
        //   state.contentList ?? [],
        //   action?.result?.data?.attributes?.data,
        // ),
        loaded: true,
        loading: false,
      };
    case `${GET_PAST_FEATURE_LIST}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}
